angular.module('app.directives').directive('interestPreview', ($templateCache, $compile) => ({
    restrict: 'EA',

    scope: {
        interest: '=',
        iconClass: '@',
    },

    templateUrl: '/directives/preview/interest_preview_link.html',

    link(scope, element, attrs) {
        scope.preview = {
            name: 'name',
            author_id: 'author.fullname',
            client_id: 'client.name',
            status_id: 'status.value',
            woodwork_id: 'woodwork.value',
            value: 'value',
        };

        scope.previewInterest = ($event) => {
            const html = $templateCache.get('/directives/preview/interest_preview.html');
            angular.element('#preview_interest_modal').html($compile(html)(scope));

            return true;
        };

        scope.setupTemplate = () => {
            if (angular.element('#preview_interest_wrapper').length) {
                return true;
            }

            angular.element('body').append('<div id="preview_interest_wrapper"><div class="uk-modal" id="preview_interest_modal" aria-hidden="true"></div></div>');
        };

        scope.setupTemplate();
    },
}));
